// /src/pages/KrogerCallback.js
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import request from '../utils/request';

export default function KrogerCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let called = false;
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const redirectUri = 'http://localhost:3001/kroger-callback';

    // decode the base64-encoded JSON we passed in `state`
    let orderId;
    if (state) {
      try {
        const payload = JSON.parse(atob(state));
        orderId = payload.orderId;
      } catch (err) {
        console.error('Invalid state payload', err);
      }
    }

    if (code && orderId && !called) {
      called = true;

      request
        .post('/orders/kroger/callback', { code, redirectUri, orderId })
        .then(res => {
          alert(`✅ ${res.data.addedCount || 0} items added to Kroger cart`);
          if (window.opener) {
            window.opener.postMessage(
              { addedCount: res.data.addedCount, totalCount: res.data.totalCount },
              window.origin
            );
            window.close();
          }
        })
        .catch(err => {
          console.error('Kroger callback failed', err);
          alert('❌ Kroger token exchange failed');
        });
    }
  }, [searchParams]);

  return <p>Adding items to cart…</p>;
}
